// extracted by mini-css-extract-plugin
export default {"wrapper":"text_wrapper__mP9Od","input":"text_input__VeOFp","config":"text_config__5AHuv","configIcon":"text_configIcon__4nBzD"};